import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import {Input} from "@/components/ui/input";
interface DatePickerProps {
    value?: string | null;
    onChange: (iso: string | null) => void;
    placeholder?: string;
    showTimeSelect?: boolean;
    className?: string;
    allowTyping?: boolean;
}

const CustomInput = React.forwardRef<HTMLInputElement, any>(
    ({ value, onClick, placeholder, className, onChange, readOnly }, ref) => {
        return (
            <Input
                ref={ref as any}
                value={value}
                onClick={onClick}
                onChange={onChange}
                placeholder={placeholder}
                className={className}
                readOnly={readOnly}
            />
        );
    }
);
CustomInput.displayName = "CustomInput";

export default function DatePicker({
                                       value,
                                       onChange,
                                       placeholder,
                                       showTimeSelect = true,
                                       className = "w-full",
                                       allowTyping = false,
                                   }: DatePickerProps) {
    const selectedDate = value ? dayjs(value).toDate() : null;

    return (
        <ReactDatePicker
            selected={selectedDate}
            onChange={(d: Date | null) => onChange(d ? d.toISOString() : null)}
            showTimeSelect={showTimeSelect}
            timeFormat="HH:mm"
            dateFormat={showTimeSelect ? "dd.MM.yyyy HH:mm" : "dd.MM.yyyy"}
            placeholderText={placeholder}
            customInput={
                <CustomInput
                    placeholder={placeholder}
                    className={className}
                    readOnly={!allowTyping}
                />
            }
        />
    );
}
